<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Salas &amp; Interações</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Salas &amp; Interações</div>
        </div>
      </div>

      <!-- Vazio -->
      <div v-if="!list.length" class="appui-emptystate">
        <div class="appui-emptystate-icon"><i class="bx bx-broadcast"></i></div>
        <div class="appui-emptystate-title">Nenhuma sala ainda</div>
        <div class="appui-emptystate-sub">Crie salas/palcos para a interação ao vivo — transmissão, chat, enquetes, quiz e nuvem de palavras.</div>
        <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Criar a primeira sala</button>
      </div>

      <!-- Bloco principal -->
      <section v-else class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <span class="appui-toolbar-hint"><i class="mdi mdi-drag-vertical"></i> Arraste para reordenar as salas no app.</span>
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Nova sala</button>
          </div>
        </div>

        <table class="appui-table">
          <thead>
            <tr>
              <th style="width:56px"></th>
              <th>Sala</th>
              <th style="width:100px">Status</th>
              <th>Abertura</th>
              <th>Encerramento</th>
              <th style="text-align:right">Ações</th>
            </tr>
          </thead>
          <draggable
            v-model="list"
            :element="'tbody'"
            :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
            @end="onReorder"
          >
            <tr v-for="r in list" :key="r.id">
              <td><span class="appui-grip" title="Arraste para reordenar">⠿</span></td>
              <td>
                <div style="display:flex;align-items:center;gap:12px">
                  <span class="appui-avatar" style="width:40px;height:40px;font-size:13px">
                    <img v-if="r.image" :src="r.image"><template v-else><i class="mdi mdi-television-play"></i></template>
                  </span>
                  <div>
                    <div style="font-weight:500;color:#495057;margin-bottom:4px">
                      <i v-if="r.allow_users" class="mdi mdi-lock-outline" style="color:#adb5bd" title="Sala restrita"></i> {{ r.name }}
                    </div>
                    <span v-if="r.slug" class="appui-badge appui-badge--blue">{{ r.slug }}</span>
                  </div>
                </div>
              </td>
              <td><span class="appui-badge" :class="r.status ? 'appui-badge--green' : 'appui-badge--muted'" role="button" @click="toggle(r)">{{ r.status ? 'Ativa' : 'Inativa' }}</span></td>
              <td style="color:#74788d">{{ fmt(r.start_date) }}</td>
              <td style="color:#74788d">{{ fmt(r.end_date) }}</td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" @click="manage(r)"><i class="mdi mdi-tune-variant"></i> Gerenciar</button>
                <button class="appui-tbtn" style="margin-right:6px" @click="openEdit(r)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="remove(r)">Excluir</button>
              </td>
            </tr>
          </draggable>
        </table>
      </section>
    </div>

    <b-modal v-model="showModal" :title="form.id ? 'Editar sala' : 'Nova sala'" size="lg" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group"><label>Nome *</label><input type="text" class="form-control" v-model="form.name" required></div>
        <div class="form-group"><label>Descrição</label><textarea class="form-control" rows="2" v-model="form.description"></textarea></div>
        <div class="row">
          <div class="form-group col-sm-6"><label>Início</label><input type="datetime-local" class="form-control" v-model="form.start_date"></div>
          <div class="form-group col-sm-6"><label>Fim</label><input type="datetime-local" class="form-control" v-model="form.end_date"></div>
        </div>
        <div class="form-group">
          <label>Imagem da sala</label>
          <input type="file" accept="image/*" ref="image" style="display:none" @change="onImg('image', $event)">
          <div class="appui-drop" :class="{ 'has-img': preview.image }" @click="$refs.image.click()">
            <template v-if="preview.image">
              <img :src="preview.image" class="appui-drop-img">
              <div class="appui-drop-overlay">
                <span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span>
                <span class="appui-drop-btn appui-drop-btn--danger" @click.stop="removeImg()"><i class="mdi mdi-delete"></i> Remover</span>
              </div>
            </template>
            <template v-else>
              <i class="mdi mdi-cloud-upload-outline appui-drop-icon"></i>
              <span class="appui-drop-title">Clique para enviar</span>
              <span class="appui-drop-hint">Banner da sala · até 2 MB</span>
            </template>
          </div>
        </div>
        <label class="appui-perm-row" style="margin-top:4px">
          <span><i class="mdi mdi-lock-outline"></i> Sala restrita (lista de acesso)</span>
          <button type="button" class="appui-switch" :class="{ 'is-on': form.allow_users }" @click="form.allow_users = form.allow_users ? 0 : 1"><span class="knob"></span></button>
        </label>
        <div class="text-right" style="margin-top:16px">
          <button type="button" class="appui-btn appui-btn--ghost" style="margin-right:8px" @click="showModal = false">Cancelar</button>
          <button type="submit" class="appui-btn appui-btn--primary" :disabled="saving">Salvar sala</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

const empty = () => ({ id: null, name: '', description: '', start_date: '', end_date: '', allow_users: 0 })

export default {
  components: { draggable },
  name: 'app-rooms',
  data () {
    return { list: [], showModal: false, saving: false, form: empty(), imageFile: null, preview: { image: null } }
  },
  mounted () { this.load() },
  methods: {
    load () {
      const loader = this.$loading.show()
      services.listRooms().then(r => { this.list = r.data.data }).catch(() => errorMessage('Falha ao carregar salas.', 3000)).finally(() => loader.hide())
    },
    fmt (d) {
      if (!d) return '—'
      const dt = new Date(d.replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    openCreate () { this.form = empty(); this.imageFile = null; this.preview = { image: null }; this.showModal = true },
    openEdit (r) { this.form = { ...empty(), ...r }; this.imageFile = null; this.preview = { image: r.image }; this.showModal = true },
    onImg (field, e) { const f = e.target.files[0]; if (!f) return; this.imageFile = f; this.preview.image = URL.createObjectURL(f) },
    removeImg () { this.imageFile = null; this.preview.image = null; this.form.image = null },
    async save () {
      this.saving = true
      try {
        const fd = new FormData()
        Object.keys(empty()).forEach(k => { if (k !== 'id' && this.form[k] != null && this.form[k] !== '') fd.append(k, this.form[k]) })
        if (this.imageFile) fd.append('image', this.imageFile)
        if (this.form.id) await services.updateRoom(this.form.id, fd)
        else await services.createRoom(fd)
        this.showModal = false; successMessage('Sala salva.', 2000); this.load()
      } catch (e) { errorMessage('Falha ao salvar sala.', 3000) } finally { this.saving = false }
    },
    async toggle (r) { try { await services.changeRoomStatus(r.id); r.status = r.status ? 0 : 1 } catch (e) { errorMessage('Falha ao alterar status.', 3000) } },
    async remove (r) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${r.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteRoom(r.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    manage (r) { this.$router.push(`/app/rooms/${r.id}`) },
    async onReorder () {
      try { await services.reorderRooms(this.list.map(it => ({ id: it.id }))) } catch (e) { errorMessage('Falha ao reordenar.', 3000); this.load() }
    }
  }
}
</script>
